import { put, select } from 'redux-saga/effects';
import notification from 'antd/lib/notification';
// internal
import history from '@app/components/router/history';
import { AccountType } from '@app/store/typings/actions/account';
import { clearInviteToken } from '@app/utils/localStorage';
import * as Action from '@app/store/typings/actions/user.d';
import * as Service from '@app/services/user';
import { handleError, convertErrorToResponse } from '@app/utils/service';
import { RootState } from '@app/store/typings/state/root';

export function* updateUser({ payload }: Action.UserUpdate) {
  try {
    const { data } = yield Service.updateUser(payload.data, payload.userId);
    if (data.success) {
      if (payload.data.file) {
        yield put<Action.UserType>({
          type: 'KEY_USER_UPLOAD_PICTURE',
          payload: {
            userId: payload.userId,
            file: payload.data.file,
          },
        });
      } else {
        yield put<Action.UserType>({ type: 'KEY_USER_MYUSER_FETCH' });
      }
      notification.success({ message: 'Success', description: 'Update profile successfully' });
    }
  } catch (error) {
    const message = convertErrorToResponse(error)?.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* changePassword({ payload }: Action.UserChangePassword) {
  try {
    const userId: string = yield select((state: RootState) => state.user.myUser?._id);
    const { data } = yield Service.updateUser(
      { password: payload.password },
      payload.userId?.userId || userId,
    );
    if (data.success) {
      notification.success({ message: 'Success', description: 'Change password successfully' });
      if (payload.pushEndUser) {
        history.push(`/project/setting/user`);
      }
    }
  } catch (error) {
    const message = convertErrorToResponse(error)?.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* updateUserInvite() {
  try {
    const state: {
      userId: string;
      firstName: string;
      lastName: string;
      password: string;
    } = yield select((state: RootState) => ({
      userId: state.user.myUser?._id,
      firstName: state.account.dataForm.firstName,
      lastName: state.account.dataForm.lastName,
      password: state.account.dataForm.password,
    }));
    const updateData = {
      firstName: state.firstName,
      lastName: state.lastName,
      password: state.password,
    };
    const { data } = yield Service.updateUserInvite(updateData, state.userId);
    if (data.success) {
      clearInviteToken();
      yield put<Action.UserType>({
        type: 'KEY_USER_MYUSER_SET_DATA',
        payload: data.data,
      });
      yield put<AccountType>({
        type: 'KEY_ACCOUNT_CREATE_SUCCESS',
      });
      yield put<AccountType>({
        type: 'KEY_ACCOUNT_LOGIN_FETCH',
        payload: { email: data.data.email, phone: data.data.phone, password: state.password },
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* uploadUserPicture({ payload }: Action.UserUploadPicture) {
  try {
    const { data } = yield Service.uploadUserPicture(payload.userId, payload.file);
    if (data.success) {
      yield put<Action.UserType>({ type: 'KEY_USER_MYUSER_FETCH' });
    }
  } catch (error) {
    const message = convertErrorToResponse(error)?.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}
